export const CART_FLY_EVENT = "cart:fly";

/*
 * Pokreće fly-to-cart animaciju iz centra prosleđenog elementa (CTA dugme).
 * Header sluša ovaj event i animira kuglicu do shopbag ikonice.
 */
export function flyToCartFrom(element) {
  if (!element) return;
  const rect = element.getBoundingClientRect();
  window.dispatchEvent(
    new CustomEvent(CART_FLY_EVENT, {
      detail: {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      },
    }),
  );
}
